import React, { useState, useEffect } from "react";
import '../components/slider.css'

const slides = [
  {
    image: "/images/PinBasket.png",
    title: "PinBasket",
    description: "PinBasket is a fast-paced arcade game that combines the classic physics of pinball with the scoring excitement of basketball. Use flippers to launch and control the ball, bouncing off bumpers and ramps to make trick shots into the hoop.",
    playStoreUrl: "",
    appStoreUrl: "",
    webUrl: "https://yandex.com/games/app/414780",
  }
];

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slider-container">
      <div className="slide">
        <img src={slides[currentSlide].image} alt="Game" className="slide-image" />
        <div className="slide-content">
          <h2 className="gameTitle">{slides[currentSlide].title}</h2>
          <p className="description">{slides[currentSlide].description}</p>
          <div className="download-buttons">
            <pre>{slides[currentSlide].playStoreUrl === "" ? 'Soon in \n': ""}Play Store</pre>
            <pre>{slides[currentSlide].appStoreUrl === "" ? 'Soon in \n': ""}App Store</pre>
            <pre>{slides[currentSlide].webUrl === "" ? 'Soon in \n': ""}Web</pre>
          </div>
        </div>
      </div>
      <div className="indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={index === currentSlide ? "active" : ""}
            onClick={() => setCurrentSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Slider;
